import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Picklist } from '../../user-defined-fields/models/Picklist';
import { CustomFieldValueStatus } from '../enums/CustomFieldValueStatus';
import { FieldType } from '../enums/FieldType';
import { FieldValidationType } from '../enums/FieldValidationType';
import { LogKind } from '../enums/LogKind';

export interface CustomFieldContentSubjectDto {
  studentId?: number | null;
  candidateId?: number | null;
}

export interface CustomFieldTabInfoDto {
  tabId: number;
  name: string;
  canEdit: boolean;
}

export interface CustomFieldTabContentDto {
  subject: CustomFieldContentSubjectDto;
  tab: CustomFieldTabInfoDto;
  categories: CustomFieldCategoryContentDto[];
}

export interface CustomFieldCategoryContentDto {
  categoryId: number;
  name: string;
  sortOrder: number;
  fields: CustomFieldContentDto[];
}

export interface CustomFieldContentDto {
  fieldId: number;
  commonFieldId?: number | null;
  name: string;
  fieldType: FieldType;
  sortOrder: number;
  required: boolean;
  useDateEffective: boolean;
  minimumAmount?: number | null;
  maximumAmount?: number | null;
  validationType?: FieldValidationType | null;
  canView: boolean;
  canEdit: boolean;
  canViewLog: boolean;
  picklistId?: number | null;
  scalarValue?: ScalarFieldValueDto | null;
  composite?: CompositeFieldValueDto | null;
}

export interface ScalarFieldValueDto {
  valueId?: number | null;
  value?: string | null;
  dateEffective?: string | Date | null;
  status?: CustomFieldValueStatus | null;
}

export interface CompositeFieldValueDto {
  childFields: CompositeChildFieldDto[];
  rows: CompositeRowDto[];
}

export interface CompositeChildFieldDto {
  fieldId: number;
  name: string;
  fieldType: FieldType;
  sortOrder: number;
  required: boolean;
  minimumAmount?: number | null;
  maximumAmount?: number | null;
  validationType?: FieldValidationType | null;
  canView: boolean;
  canEdit: boolean;
  picklistId?: number | null;
}

export interface CompositeRowDto {
  rowId?: number | null;
  clientRowId?: string | null;
  dateEffective?: string | Date | null;
  cells: CompositeCellDto[];
}

export interface CompositeCellDto {
  fieldId: number;
  valueId?: number | null;
  value?: string | null;
}

export enum CustomFieldChangeOperation {
  Upsert = 0,
  Delete = 1
}

export interface SaveCustomFieldContentCommand {
  subject: CustomFieldContentSubjectDto;
  tabId: number;
  scalarChanges: ScalarFieldChangeDto[];
  compositeChanges: CompositeFieldChangeDto[];
}

export interface ScalarFieldChangeDto {
  fieldId: number;
  valueId?: number | null;
  operation: CustomFieldChangeOperation;
  value?: string | null;
  dateEffective?: string | Date | null;
}

export interface CompositeFieldChangeDto {
  fieldId: number;
  rows: CompositeRowChangeDto[];
}

export interface CompositeRowChangeDto {
  rowId?: number | null;
  clientRowId?: string | null;
  operation: CustomFieldChangeOperation;
  dateEffective?: string | Date | null;
  cells: CompositeCellChangeDto[];
}

export interface CompositeCellChangeDto {
  fieldId: number;
  valueId?: number | null;
  value?: string | null;
}

export interface FieldLogDto {
  fieldId: number;
  rows: FieldLogRowDto[];
}

export interface FieldLogRowDto {
  logId: number;
  valueId: number;
  logKind: LogKind;
  oldValue?: string | null;
  newValue?: string | null;
  oldDateEffective?: string | Date | null;
  newDateEffective?: string | Date | null;
  createdDate: string | Date;
  creator: string;
}

export interface CompositeFieldLogDto {
  fieldId: number;
  groups: CompositeLogGroupDto[];
}

export interface CompositeLogGroupDto {
  parentValueId?: number | null;
  logKind: LogKind;
  createdDate: string | Date;
  creator: string;
  dateEffective?: string | Date | null;
  cells: CompositeLogCellDto[];
  collapsed?: boolean;
}

export interface CompositeLogCellDto {
  childFieldId: number;
  childFieldName: string;
  oldValue?: string | null;
  newValue?: string | null;
}

export interface CustomFieldTabContentVm {
  subject: CustomFieldContentSubjectDto;
  tab: CustomFieldTabInfoVm;
  categories: CustomFieldCategoryVm[];
}

export interface CustomFieldTabInfoVm {
  tabId: number;
  name: string;
  canEdit: boolean;
}

export interface CustomFieldCategoryVm {
  categoryId: number;
  name: string;
  sortOrder: number;
  fields: CustomFieldVm[];
}

export interface CustomFieldVm {
  fieldId: number;
  commonFieldId?: number | null;
  name: string;
  fieldType: FieldType;
  sortOrder: number;
  required: boolean;
  useDateEffective: boolean;
  minimumAmount?: number | null;
  maximumAmount?: number | null;
  validationType?: FieldValidationType | null;
  canView: boolean;
  canEdit: boolean;
  canViewLog: boolean;
  picklistId?: number | null;
  picklist?: Picklist | undefined;
  scalarValue?: ScalarFieldValueVm;
  composite?: CompositeFieldVm;
}

export interface ScalarFieldValueVm {
  valueId?: number | null;
  value?: any;
  dateEffective?: Date | null;
  originalValue?: any;
  originalDateEffective?: Date | null;
  status?: CustomFieldValueStatus | null;
}

export interface CompositeFieldVm {
  childFields: CompositeChildFieldVm[];
  rows: CompositeRowVm[];
}

export interface CompositeChildFieldVm {
  fieldId: number;
  commonFieldId?: number | null;
  name: string;
  fieldType: FieldType;
  sortOrder: number;
  required: boolean;
  minimumAmount?: number | null;
  maximumAmount?: number | null;
  validationType?: FieldValidationType | null;
  canView: boolean;
  canEdit: boolean;
  picklistId?: number | null;
  picklist?: Picklist | undefined;
}

export interface CompositeRowVm {
  rowId?: number | null;
  clientRowId: string;
  dateEffective?: Date | null;
  originalDateEffective?: Date | null;
  deleted: boolean;
  cells: CompositeCellVm[];
}

export interface CompositeCellVm {
  fieldId: number;
  valueId?: number | null;
  value?: any;
  originalValue?: any;
}
